import { ComponentType, ReactNode } from "react";

import { IconComponent } from "types/Icon";
import { DocsUrl } from "utils/getDocsUrl";

const tuple = <T extends string[]>(...args: T) => args;

export const IntegrationType = tuple(
  "source_code",
  "cloud",
  "communication",
  "observability",
  "idp",
  "api"
);
export type IntegrationType = (typeof IntegrationType)[number];

type BaseIntegration = {
  id: string;
  name: string;
  description: string;
  icon: IconComponent;
  docsLink?: DocsUrl;
  hasViewScreen?: boolean;
  isNew?: boolean;
  type: IntegrationType;
};

type IntegrationWithViewScreen = BaseIntegration & {
  hasViewScreen: true;
  docsLink?: DocsUrl;
  // component that renders the integration list view screen.
  page: () => Promise<{ default: ComponentType }>;
  // component that renders the integration details view screen.
  detailsPage?: () => Promise<{ default: ComponentType }>;
  // used to enable/disable search based on whether the original pages has search available.
  // once we're done migrating the pages, we will work on making search available for all integrations.
  hasSearch?: boolean;
};

export type IntegrationView =
  | IntegrationWithViewScreen
  | (BaseIntegration & {
      hasViewScreen?: false;
      docsLink: DocsUrl;
      page?: never;
    });

export type IntegrationsOutletContext = {
  integration: IntegrationWithViewScreen;
  setLayoutActions: (actions: ReactNode) => void;
  setLayoutMeta: (meta: ReactNode) => void;
  setLayoutHeading: React.Dispatch<React.SetStateAction<string>>;
};
